import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/fraunces/600.css";
import "@fontsource/fraunces/700.css";
import "@fontsource/manrope/400.css";
import "@fontsource/manrope/600.css";
import "@fontsource/manrope/700.css";
import "@fontsource/noto-sans-thai/400.css";
import "./styles/base.css";
import { App } from "./app/App.tsx";
import { SessionProvider } from "./app/session.tsx";
import { TripProvider } from "./app/trip.tsx";
import { setupPwa } from "./register-sw.ts";

setupPwa();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SessionProvider>
      <TripProvider>
        <App />
      </TripProvider>
    </SessionProvider>
  </StrictMode>,
);
